<div class="dragwrapper" cdkDragHandle *ngIf="!widgetMeta?.noDrag">
  <mat-icon (mousedown)="pageService.widgetSelectedForDrag($event)"
  (mouseup)="pageService.widgetReleaseFromDrag($event)"  class="draghandle">drag_indicator</mat-icon>
</div>
